import { Grid } from '@material-ui/core';
import React  from 'react';
import PropTypes from 'prop-types';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import Button from '../../../buttons/components/Button';

const ExportInvoiceData = ({onExport, isLoadingExportData}) => {

    return (
        <Grid container>
            <Grid item>
                    <Button
                        startIcon={<ImportExportIcon />}
                        disabled={false}
                        color="primary"
                        variant="contained"
                        onClick={onExport}
                        isLoading={isLoadingExportData}
                    >
                    Rechnungsdaten Exportieren
                </Button>
            </Grid>
        </Grid>
    );
}

ExportInvoiceData.propTypes = {
    onExport: PropTypes.func.isRequired,
    isLoadingExportData: PropTypes.bool.isRequired
};

ExportInvoiceData.defaultProps = {
    onExport: () => {},
    isLoadingExportData: false
};

export default ExportInvoiceData;